import React from 'react';
import { Tabs, Tab } from '@mui/material';
import { useMatch } from 'react-router-dom';
import { Page, Row } from '../util/Page';
import SwaggerUi from './AuthorizedSwaggerUi';
import Clients from './Clients';
import Community from './Community';
import GettingStarted from './GettingStarted';
import './api-docs.css';

const IS_RTEM = import.meta.env.VITE_APP_WHICH === 'nyserda';

const content = (tab) => {
  switch (tab) {
    case 'clients':
      return <Clients />;
    case 'community':
      return <Community />;
    case 'getting-started':
      return <GettingStarted />;
    case 'swagger':
    default:
      return <SwaggerUi />;
  }
};

const NAMES = {
  'getting-started': 'Getting started',
  swagger: 'API Documentation',
  clients: 'API Clients',
  community: 'Community',
};
const TABS = Object.keys(NAMES);

const ApiAndDocs = ({ navigate }) => {
  const match = useMatch('/docs/:tab/*');
  const { tab } = match?.params ?? {};
  const tabIndex = Math.max(TABS.indexOf(tab), 0);
  const resolvedTab = TABS[tabIndex];
  return (
    <Page name="api-docs">
      <Row>
        <Tabs
          indicatorColor="secondary"
          textColor="inherit"
          value={tabIndex}
          onChange={(e, val) => navigate(`/docs/${TABS[val]}`)}
        >
          {TABS.filter((t) => !IS_RTEM || t !== 'clients').map((t) => (
            <Tab key={t} label={NAMES[t]} />
          ))}
        </Tabs>
      </Row>
      <Row>{content(resolvedTab)}</Row>
    </Page>
  );
};

export default ApiAndDocs;
